import { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router";
import { Toaster } from "sonner";
import App from "@/App";
import { trackPageView } from "@/lib/analytics";

function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

const AppRouter = () => {
  return (
    <BrowserRouter>
      <PageViewTracker />
      <App />
      <Toaster position="top-center" />
    </BrowserRouter>
  );
};

export default AppRouter;
